module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote2.3ac82cf6.svg";